import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { inject, PropType, ref } from "vue";
import { IUmbracoFormField } from "@/models/umbraco-forms/IUmbracoFormField";
import { IUmbracoFormUserPreValues } from "@/models/umbraco-forms/IUmbracoFormUserPreValues";
import { UmbracoFormParseMagicString } from "@/code/UmbracoFormExtensions";


export default /*#__PURE__*/_defineComponent({
  __name: 'UmbracoFormRecaptcha3',
  props: {
  field: {
    type: Object as PropType<IUmbracoFormField>,
    required: true,
  },
},
  setup(__props) {

const props = __props;


const value = ref<string>();
const prevalues = inject<IUmbracoFormUserPreValues>("prevalues");
if (prevalues) {
  value.value = UmbracoFormParseMagicString(prevalues, props.field?.settings.defaultValue);
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("p", null, "Recaptcha V3 (UmbracoFormRecaptcha3.vue)"))
}
}

})